import React from "react";
import "./reviews/reviews.css"
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { findMovieVideoThunk } from "../services/movies-thunks";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import MediaQuery from "react-responsive";

function MovieClipSection() {
    const { video } = useSelector((state) => state.video);
    const dispatch = useDispatch();
    const { id } = useParams();
     useEffect(() => {
       dispatch(findMovieVideoThunk(id));
     }, [dispatch, id]);
    return (
      <>
        {video && (
          <div className="wd-review-div wd-blackBackground">
            <div className="wd-review-content">
              <div className="col-8">
                <h3 style={{ color: "white" }}>Movie Clip</h3>
                <br />
                <MediaQuery minDeviceWidth={1224}>
                  <ReactPlayer
                    url={video}
                    playing={false}
                    loop={false}
                    width="100%"
                    height="55vh"
                    config={{
                      youtube: {
                        playerVars: { modestbranding: 1 },
                      },
                    }}
                  />
                </MediaQuery>
              </div>
            </div>
            <MediaQuery maxDeviceWidth={768}>
              <ReactPlayer
                url={video}
                playing={false}
                loop={false}
                width="100%"
                height="30vh"
                config={{
                  youtube: {
                    playerVars: { modestbranding: 1 },
                  },
                }}
              />
            </MediaQuery>
          </div>
        )}
      </>
    );
}

export default MovieClipSection;

